import { FeedApiResponse, FeedItem } from 'reactApp/modules/feed/feed.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';

export interface GalleryItem extends Omit<FeedItem, 'storage'> {
    storage: EStorageType.gallery;
}

export enum GalleryCategoryType {
    all = 'all',
    desktop = 'desktop',
    mobile = 'mobile',
}

export interface GalleryCategory {
    name: string;
    id: GalleryCategoryType;
    value: GalleryCategoryType;
    childs: string[];
    cursor: string;
    isLoaded: boolean;
    isLoading: boolean;
    hasMoreToLoad: boolean;
}

export interface GalleryState {
    categories: GalleryCategory[];
    currentCategory: GalleryCategoryType;
    list: {};
}

export interface GalleryLoadSuccessAction {
    category: GalleryCategoryType;
    data: FeedApiResponse;
}

export interface ChangeGalleryCategoryAction {
    category: GalleryCategoryType;
}

export interface GalleryLoadRequestAction {
    category: GalleryCategoryType;
}

export interface GalleryLoadMoreSuccessAction {
    data: FeedApiResponse;
    category: GalleryCategoryType;
}
